import { memo } from "react";
import { useTranslation } from "@/hooks/useTranslation";

export const LoginFormHeader = memo(function LoginFormHeader() {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <h2 className="text-3xl font-bold text-foreground mb-2">
        {t('auth.signIn')}
      </h2>
      <p className="text-sm text-muted-foreground">
        {t('placeholders.login.description')}
      </p>
    </div>
  );
});

